import { useEffect, useState } from "react";
import Image from "next/image";
import styles from "../styles/SupporterModal.module.css";
import CheckoutButton from "./CheckoutButton";
import { useSelector } from "react-redux";
import enpopup from "../../locales/en/paymentcontent.json";
import espopup from "../../locales/es/paymentcontent.json";

export default function PaymentPopup({
  image_path,
  heading,
  title,
  amount,
  description,
  onClose,
  id,
  iScommunity,
  project = null,
  type
}) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [frequency, setFrequency] = useState("monthly");
  const [customAmount, setCustomAmount] = useState("");
  const [formError, setFormError] = useState("");
  const customer_email = useSelector((state) => state.auth.email);
  const loginUserId = useSelector((state) => state.auth.userId);
  const Languages = useSelector((state) => state.auth.lang);
  const [content, setContent] = useState(enpopup);

  useEffect(() => {
    setContent(Languages === "es" ? espopup : enpopup);
  }, [Languages]);

  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  // ✅ Validation triggered only when clicking Checkout
  const handleSubmit = () => {
    if (!loginUserId && !email) {
      setFormError(content.email_required);
      return false;
    }
    if (!loginUserId && !validateEmail(email)) {
      setFormError(content.invalid_email);
      return false;
    }
    if (!amount && (!customAmount || Number(customAmount) <= 0)) {
      setFormError(content.enter_amount);
      return false;
    }
    setFormError("");
    return true;
  };

  return (
    <div
      className={`${styles.overlay} d-flex justify-content-center align-items-center`}
      onClick={(e) => {
        if (e.target.classList.contains(styles.overlay)) {
          onClose();
        }
      }}
    >
      <div className={styles.bgCircle}></div>

      <div className="card border-0 rounded-4 p-4 text-center position-relative" style={{ maxWidth: "350px", zIndex: 2 }}>
        <button onClick={onClose} className={`${styles.closeIcon}`} style={{ width: "32px", height: "32px" }}>
          {content.close}
        </button>

        {image_path && (
          <div className="mb-2">
            <Image src={image_path} alt={heading} width={80} height={80} />
            <div className={`${styles.communityBadge} mb-3`}>{heading}</div>
          </div>
        )}

        <div className={`${styles.titleText} mb-3`}>{title}</div>
        <p className="paragraph-2">{project}</p>

        {iScommunity && (
          <>
            <div className={`${styles.toggleBtnGroup} mb-3`}>
              <button
                className={`${styles.toggleBtn} ${frequency === "onetime" ? styles.bgPrimary : styles.bgLight}`}
                onClick={() => setFrequency("onetime")}
              >
                {content.one_time}
              </button>
              <button
                className={`${styles.toggleBtn} ${frequency === "monthly" ? styles.bgPrimary : styles.bgLight}`}
                onClick={() => setFrequency("monthly")}
              >
                {content.monthly}
              </button>
            </div>

            <div className="community-price">
              {amount ? (
                <>
                  ${amount}<span className="fw-normal">{content.per_month}</span>
                </>
              ) : (
                content.custom
              )}
            </div>
          </>
        )}

        {!amount && (
          <div className="mb-3 text-start">
            <div className="input-group">
              <span className="input-group-text large">$</span>
              <input
                type="number"
                className="input w-input form-control"
                id="amount"
                placeholder={content.enter_amount}
                value={customAmount}
                onChange={(e) => setCustomAmount(e.target.value)}
                min="1"
              />
            </div>
          </div>
        )}

        {!loginUserId && (
          <div className="mb-3 text-start">
            <input
              type="email"
              className="input w-input form-control"
              id="email"
              placeholder={content.enter_email}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        )}

        {formError && <small className="text-danger d-block mb-3">{formError}</small>}

        <CheckoutButton
          Sty="cta-btn m-auto"
          proccess={content.processing}
          donate_now={description}
          id={id}
          amount={customAmount || amount}
          type={type}
          issubscription={
            type === "community"
              ? frequency === "monthly"
              : type === "project"
                ? false
                : type === "beneficiary"
                  ? true
                  : false
          }
          email={loginUserId ? customer_email : email}
          onValidate={handleSubmit}
        />
      </div>
    </div>
  );
}

